import { Component, inject, input } from '@angular/core';
import { PackageCardComponent } from '../../../offer-list/components/package-card/package-card.component';
import { RecommendedPackageHallo } from '@data/domain/promo.entity';
import { TranslatePipe } from '@ngx-translate/core';
import { PackageCard } from '../../../offer-list/components/package-card/package-card';
import { PromoDetailData } from '@presentation/landing/component/promo-detail/promo-detail';
import { DialogService } from '@shared/component.dialog';
import { PromoDetailComponent } from '@presentation/landing/component/promo-detail/promo-detail.component';

@Component({
  selector: 'app-recomendation-package',
  standalone: true,
  imports: [PackageCardComponent, TranslatePipe],
  templateUrl: './recomendation-package.component.html',
  styleUrl: './recomendation-package.component.scss'
})
export class RecomendationPackageComponent {
  data = input<RecommendedPackageHallo>({
    name: '',
    desc: '',
    longdesc: '',
    productid: '',
    price: '',
    priceNumber: 0,
    bonus: [],
    terms: '',
    quota: '',
    validity: '',
    trxpackage: ''
  });

  private readonly dialogService = inject(DialogService);


  handlePackageCardData(event: RecommendedPackageHallo) {
    return {
      ...event,
      price: Number(event.price)
    } as PackageCard;
  }

  onCickPackage(event: RecommendedPackageHallo) {
    const DIALOG_DATA:PromoDetailData = {
      id: event.productid,
      price: event.priceNumber,
      longdesc: event.longdesc,
      terms: event.terms,
      name: event.name,
      trxpackage: event.trxpackage,
      quota: event.quota,
      bonus: event.bonus,
      isAffiliatePackage: false
    };
    this.dialogService.open(PromoDetailComponent, {
      data: DIALOG_DATA
    });
  }
}
